import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Layout from '../layout/Layout'
import VehicleCreateForm from '../molecules/VehicleCreateForm'
import { CREATE_MOTORBIKE } from 'src/redux/motorbikesReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

export interface MotorbikeFormData {
  model: string
  brand_id: number
  vin: string
  motorbike_name: string | null
  rails_app_id: string | null
  rails_app_hash_id: string | null
  first_registration: string | null
  total_mileage: string | null
  engine_power: string | null
  number_of_previous_owners: string | null
  capacity: string | null
  metallic: boolean | null
  drive_type: string | null
  gear_box: string | null
  damage_unrepaired: boolean | null
  abs: boolean | null
  heated_grips: boolean | null
  box: boolean | null
  windshield: boolean | null
  next_hu: string | null
  full_service_history: boolean | null
}

const MotorbikeCreate = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleCancel = (): void => {
    navigate('/selling/vehicles')
  }

  const onSubmit = (values: MotorbikeFormData): void => {
    dispatch(CREATE_MOTORBIKE(values))
    dispatch(
      SHOW_TOAST({
        message: t('my_vehicles.toast_vehicle_added'),
        actionLabel: t('my_vehicles.toast_issue_invoice'),
        actionPath: '/selling/clients'
      })
    )
    navigate('/selling/vehicles')
  }

  const initialValues: MotorbikeFormData = {
    model: '',
    brand_id: 0,
    vin: '',
    motorbike_name: null,
    rails_app_id: null,
    rails_app_hash_id: null,
    first_registration: null,
    total_mileage: null,
    engine_power: null,
    number_of_previous_owners: null,
    capacity: null,
    metallic: null,
    drive_type: null,
    gear_box: null,
    damage_unrepaired: null,
    abs: null,
    heated_grips: null,
    box: null,
    windshield: null,
    next_hu: null,
    full_service_history: null
  }

  return (
    <Layout withoutToolbar>
      <div className="flex flex-col justify-start items-start gap-4 h-[calc(100vh-100px)]">
        <div className="self-stretch h-14 min-h-14 bg-Estigroup-primary rounded-lg border border-neutral-200 flex flex-col justify-start items-center">
          <div className="self-stretch flex-1 px-4 py-3 inline-flex justify-start items-center">
            <div className="text-foregrounds-fg-on-color text-xl font-semibold font-Montserrat">
              {t('my_vehicles.add_vehicle')}
            </div>
          </div>
        </div>
        <VehicleCreateForm initialValues={initialValues} onSubmit={onSubmit} onCancel={handleCancel} />
      </div>
    </Layout>
  )
}

export default MotorbikeCreate
